import React from "react";

export default function HorizontalTabs({
  data,
  selectedTab,
  setSelectedTab,
  activeClass,
}) {
  return (
    <ul className="horizontalTabs">
      {data.map(({ id, label, value, show = true, disableClick = false }) => {
        if (!show) {
          return null;
        }
        const mainKey = id || value;
        return (
          <li
            key={mainKey}
            className={`tab ${selectedTab === mainKey ? activeClass : ""} ${disableClick ? "nonClickableTab" : "clickableTab"}`}
            id={mainKey}
            onClick={() => disableClick ? null : setSelectedTab(mainKey)}
          >
            {label}
          </li>
        );
      })}
    </ul>
  );
}

HorizontalTabs.defaultProps = {
  data: [],
  onSelect: () => {},
  activeClass: "active",
};
